import { useNavigate, useParams } from "react-router-dom";
import { getTemplateById, updateTemplate } from "../api/templates";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import {
  addWidgetOptions,
  addZIndex,
  convertPdfArrayBuffer,
  defaultWidthHeight,
  getBase64FromUrl,
  getContainerScale,
  pdfNewWidthFun,
  radioButtonWidget,
  randomId,
  textInputWidget,
  textWidget,
} from "../utils/general";
import RenderAllPdfPage from "../components/document/RenderAllPdfPage";
import { DndProvider, useDrop } from "react-dnd";
import RenderPdf from "../components/document/RenderPdf";
import { HTML5Backend } from "react-dnd-html5-backend";
import PrevNext from "../components/document/PrevNext";
import WidgetComponent from "../components/document/WidgetComponent";
import SignerListPlace from "../components/document/SignerListPlace";
import PlaceholderCopy from "../components/document/PlaceholderCopy";
import { CheckBadgeIcon, PencilIcon } from "@heroicons/react/24/outline";
import DropdownWidgetOption from "../components/document/DropdownWidgetOption";
import TextInputWidgetOption from "../components/document/TextInputWidgetOption";
import DateWidgetOption from "../components/document/DateWidgetOption";
import { ArrowLeftCircleIcon } from "@heroicons/react/16/solid";
import SendConfirmationModal from "../components/SendConfirmationModal";
import { useLoading } from "../contexts/LoadingContext";
import { v4 as uuidv4 } from "uuid";
import PagePermissionGuard from "../components/common/PagePermissionGuard";
import SignPad from "../components/document/SignPad";

const SelfSignConfigure = ({
  templateUseData = null,
  continueSignCallBack = () => {},
}) => {
  const isFromUseTemplate = false;
  const isFromSelfSign = true;
  const sendEmail = () => {};
  const navigate = useNavigate();
  const { templateId } = useParams();
  const divRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [templateData, setTemplateData] = useState(null);
  const [pdfBase64Url, setPdfBase64Url] = useState(null);
  const [pdfArrayBuffer, setPdfArrayBuffer] = useState(null);
  const [allPages, setAllPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [signBtnPosition, setSignBtnPosition] = useState(null);
  const [isSignPad, setIsSignPad] = useState(false);
  const [isUploadPdf, setIsUploadPdf] = useState(false);
  const [isStamp, setIsStamp] = useState(false);
  const [isImageSelect, setIsImageSelect] = useState(false);
  const [image, setImage] = useState(null);
  const [imageRef, setImageRef] = useState(null);
  const [signature, setSignature] = useState(null);
  const [defaultSignImg, setDefaultSignImg] = useState(null);
  const [myInitial, setMyInitial] = useState(null);
  const [isInitial, setIsInitial] = useState(false);
  const [isAutoSign, setIsAutoSign] = useState(false);
  const [saveSignCheckbox, setSaveSignCheckbox] = useState({
    isVisible: false,
    signId: "",
  });
  const [signatureType, setSignatureType] = useState([
    { name: "draw", enabled: true },
    { name: "typed", enabled: true },
  ]);
  const [signerObjectId, setSignerObjectId] = useState();
  const [signedSigners, setSignedSigners] = useState([]);
  const [validateAlert, setValidateAlert] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [isTextSetting, setIsTextSetting] = useState(false);
  const [assignedWidgetId, setAssignedWidgetId] = useState("");
  const [requestSignTour, setRequestSignTour] = useState(false);
  const [minRequiredCount, setminRequiredCount] = useState();
  const [imgWH, setImgWH] = useState({});
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [declineError, setDeclineError] = useState("");
  const [containerWH, setContainerWH] = useState();
  const [pdfNewWidth, setPdfNewWidth] = useState();
  const [scale, setScale] = useState(1);
  const [zoomPercent, setZoomPercent] = useState(0);
  const [pdfOriginalWH, setPdfOriginalWH] = useState([]);
  const [pdfLoad, setPdfLoad] = useState(false);
  const [, drop] = useDrop({
    accept: "BOX",
    drop: (item, monitor) => addPositionOfSignature(item, monitor),
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
  });
  const [widgetName, setWidgetName] = useState(false);
  const [dragKey, setDragKey] = useState();
  const [isDragging, setIsDragging] = useState(false);
  const [xySignature, setXYSignature] = useState({});

  const [uniqueId, setUniqueId] = useState(4896);

  const [signersdata, setSignersData] = useState([]);
  const [zIndex, setZIndex] = useState(1);
  const [owner, setOwner] = useState({});
  const [signerPos, setSignerPos] = useState([]);
  const [isCheckbox, setIsCheckbox] = useState(false);
  const [isRadio, setIsRadio] = useState(false);
  const [isTextInput, setIsTextInput] = useState(false);
  const [isDateModal, setIsDateModal] = useState(false);

  const [fontSize, setFontSize] = useState();
  const [fontColor, setFontColor] = useState();

  const [currWidgetsDetails, setCurrWidgetsDetails] = useState([]);
  const [widgetType, setWidgetType] = useState("");
  const [signKey, setSignKey] = useState();

  const [selectWidgetId, setSelectWidgetId] = useState("");
  const [IsReceipent, setIsReceipent] = useState(true);
  const [isResize, setIsResize] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isNameModal, setIsNameModal] = useState(false);
  const [isSelectListId, setIsSelectId] = useState();
  const [tempSignerId, setTempSignerId] = useState("");
  const [unSignedWidgetId, setUnSignedWidgetId] = useState("");
  const [isPageCopy, setIsPageCopy] = useState(false);

  const [roleName, setRoleName] = useState("");
  const [blockColor, setBlockColor] = useState("");
  const [isCC, setIsCC] = useState([]);

  const [showSendModal, setShowSendModal] = useState(false);
  const [isAskForAttachments, setIsAskForAttachments] = useState(false);
  const [documentRequiredMessage, setDocumentRequiredMessage] = useState("");
  const { showLoader, hideLoader } = useLoading();

  // Function to handle image change for signature upload
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  // Function to save signature image
  const saveImage = (imgData) => {
    // console.log("Saving signature image:", imgData);
    // Logic to save the signature image will be added here
  };

  // Function to save drawn signature
  const saveSign = (signData) => {
    // console.log("Saving signature:", signData);
    // Logic to save the signature will be added here
  };

  // Function to handle text setting modal
  const handleTextSettingModal = () => {
    setIsTextSetting(!isTextSetting);
  };

  // Function to open date modal
  const openDateModal = () => {
    // Date modal logic will be added here
  };

  const setLocalFormState = async (template) => {
    if (!template) return;

    // Check if we have local PDF data (from file selection)
    if (template.documentId?.arrayBuffer && template.documentId?.base64Url) {
      setPdfBase64Url(template.documentId.base64Url);
      setPdfArrayBuffer(template.documentId.arrayBuffer);
    } else if (template.documentId?.filePath) {
      // Fallback to URL-based loading (for backward compatibility)
      const url = template.documentId.filePath;
      try {
        const arrayBuffer = await convertPdfArrayBuffer(
          `${process.env.REACT_APP_FILE_URL}/${url.replace(/\\/g, "/")}`
        );
        const base64Pdf = await getBase64FromUrl(
          `${process.env.REACT_APP_FILE_URL}/${url.replace(/\\/g, "/")}`
        );
        if (arrayBuffer === "Error") {
          toast.error("Something went wrong loading PDF");
        } else {
          setPdfBase64Url(base64Pdf);
          setPdfArrayBuffer(arrayBuffer);
        }
      } catch (error) {
        console.error("Error loading PDF:", error);
        toast.error("Failed to load PDF");
      }
    }
    const RECIPIENT_COLORS_HEX = {
      "bg-blue-500": "#3b82f6",
      "bg-green-500": "#22c55e",
      "bg-yellow-500": "#eab308",
      "bg-purple-500": "#a855f7",
      "bg-pink-500": "#ec4899",
      "bg-indigo-500": "#6366f1",
      "bg-red-500": "#ef4444",
      "bg-teal-500": "#14b8a6",
    };

    const templateRecipients = [...template.recipients];
    setIsCC(templateRecipients.filter((item) => item.isCC));
    const filteredRecipients = templateRecipients.filter((item) => !item.isCC);

    const allSigners = filteredRecipients.map((item) => ({
      ...item,
      placeHolder: item?.placeHolder ? item?.placeHolder : [],
      color: RECIPIENT_COLORS_HEX[item.color],
      blockColor: RECIPIENT_COLORS_HEX[item.color],
      Role: item._id,
      signerObjId: item._id,
      Id: item._id || uuidv4(),
    }));
    setSignersData(allSigners);
    setSignerPos(allSigners);

    setIsSelectId(0);
    setUniqueId(allSigners[0]?.Id);
    setRoleName(allSigners[0]?.role);
    setBlockColor(allSigners[0]?.blockColor);
    setDocumentRequiredMessage(template.documentRequiredMessage);
    setIsAskForAttachments(template.documentRequired);
  };
  useEffect(() => {
    const templateDataCallback = async () => {
      setTemplateData(templateUseData);
      await setLocalFormState(templateUseData);
    };
    templateDataCallback();
  }, [isFromUseTemplate, templateId, templateUseData]);

  useEffect(() => {
    const updateSize = () => {
      if (divRef.current) {
        const pdfWidth = pdfNewWidthFun(divRef);
        setPdfNewWidth(pdfWidth);
        setContainerWH({
          width: divRef.current.offsetWidth,
          height: divRef.current.offsetHeight,
        });
        setScale(1);
        setZoomPercent(0);
      }
    };

    // Use setTimeout to wait for the transition to complete
    const timer = setTimeout(updateSize, 100); // match the transition duration

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divRef.current]);

  const addPositionOfSignature = (item, monitor) => {
    if (item && item.text) {
      setWidgetName(item.text);
    }
    getSignerPos(item, monitor);
  };

  const getSignerPos = (item, monitor) => {
    try {
      // console.log(uniqueId);
      if (uniqueId) {
        const signer = signersdata.find((x) => x.Id === uniqueId);

        if (signer) {
          const posZIndex = zIndex + 1;
          setZIndex(posZIndex);
          const containerScale = getContainerScale(
            pdfOriginalWH,
            pageNumber,
            containerWH
          );
          const key = randomId();
          const dragTypeValue = item?.text ? item.text : monitor.type;
          const widgetWidth =
            defaultWidthHeight(dragTypeValue).width * containerScale;
          const widgetHeight =
            defaultWidthHeight(dragTypeValue).height * containerScale;
          let dropData = [],
            currentPagePosition,
            filterSignerPos;
          let placeHolder;
          if (item === "onclick") {
            // `getBoundingClientRect()` is used to get accurate measurement height of the div
            const divHeight = divRef.current.getBoundingClientRect().height;
            const dropObj = {
              //onclick put placeholder center on pdf
              xPosition: widgetWidth / 4 + containerWH.width / 2,
              yPosition: widgetHeight + divHeight / 2,
              isStamp:
                (dragTypeValue === "stamp" || dragTypeValue === "image") &&
                true,
              key: key,
              scale: containerScale,
              zIndex: posZIndex,
              type: dragTypeValue,
              options: addWidgetOptions(dragTypeValue, owner),
              Width: widgetWidth / (containerScale * scale),
              Height: widgetHeight / (containerScale * scale),
            };
            dropData.push(dropObj);
            placeHolder = { pageNumber: pageNumber, pos: dropData };
          } else {
            const offset = monitor.getClientOffset();
            //adding and updating drop position in array when user drop signature button in div
            const containerRect = document
              .getElementById("container")
              .getBoundingClientRect();
            const x = offset.x - containerRect.left;
            const y = offset.y - containerRect.top;
            const getXPosition = signBtnPosition[0]
              ? x - signBtnPosition[0].xPos
              : x;
            const getYPosition = signBtnPosition[0]
              ? y - signBtnPosition[0].yPos
              : y;
            const dropObj = {
              xPosition: getXPosition / (containerScale * scale),
              yPosition: getYPosition / (containerScale * scale),
              isStamp:
                (dragTypeValue === "stamp" || dragTypeValue === "image") &&
                true,
              key: key,
              scale: containerScale,
              // isMobile: isMobile,
              zIndex: posZIndex,
              type: item.text,
              options: addWidgetOptions(dragTypeValue, owner),
              Width: widgetWidth / (containerScale * scale),
              Height: widgetHeight / (containerScale * scale),
            };

            dropData.push(dropObj);
            placeHolder = { pageNumber: pageNumber, pos: dropData };
          }
          if (dragTypeValue === textWidget) {
            filterSignerPos = signerPos.find((data) => data.Role === "prefill");
          } else {
            filterSignerPos = signerPos.find((data) => data.Id === uniqueId);
          }

          const getPlaceHolder = filterSignerPos?.placeHolder;
          if (getPlaceHolder) {
            //checking exist placeholder on same page
            currentPagePosition = getPlaceHolder.find(
              (data) => data.pageNumber === pageNumber
            );
          }

          //checking current page has already some placeholders then update that placeholder and add upcoming placehoder position
          if (getPlaceHolder && currentPagePosition) {
            const updatePlace = getPlaceHolder.filter(
              (data) => data.pageNumber !== pageNumber
            );
            const getPos = currentPagePosition?.pos;
            const newSignPos = getPos.concat(dropData);
            let xyPos = { pageNumber: pageNumber, pos: newSignPos };
            updatePlace.push(xyPos);
            let updatesignerPos;
            if (dragTypeValue === textWidget) {
              updatesignerPos = signerPos.map((x) =>
                x.Role === "prefill" ? { ...x, placeHolder: updatePlace } : x
              );
            } else {
              updatesignerPos = signerPos.map((x) =>
                x.Id === uniqueId ? { ...x, placeHolder: updatePlace } : x
              );
            }
            setSignerPos(updatesignerPos);
            //// console.log(signerPos, "signerPos");
          } else {
            //if condition when widget type is prefill label text widget
            if (dragTypeValue === textWidget) {
              //check text widgets data (prefill) already exist then and want to add text widget on new page
              //create new page entry with old data and update placeholder
              if (filterSignerPos) {
                const addPrefillData =
                  filterSignerPos && filterSignerPos?.placeHolder;
                addPrefillData.push(placeHolder);
                const updatePrefillPos = signerPos.map((x) =>
                  x.Role === "prefill"
                    ? { ...x, placeHolder: addPrefillData }
                    : x
                );
                setSignerPos(updatePrefillPos);
                //// console.log(signerPos, "signerPos");
              } //else condition if user do not have any text widget data
              else {
                const prefillTextWidget = {
                  signerPtr: {},
                  signerObjId: "",
                  blockColor: "#f58f8c",
                  placeHolder: [placeHolder],
                  Role: "prefill",
                  Id: key,
                };
                setSignerPos((prev) => [...prev, prefillTextWidget]);
                //// console.log(signerPos, "signerPos");
              }
            } else {
              //else condition to add placeholder widgets on multiple page first time
              const updatesignerPos = signerPos.map((x) =>
                x.Id === uniqueId && x?.placeHolder
                  ? { ...x, placeHolder: [...x.placeHolder, placeHolder] }
                  : x.Id === uniqueId
                  ? { ...x, placeHolder: [placeHolder] }
                  : x
              );
              setSignerPos(updatesignerPos);
            }
          }

          // if (dragTypeValue === "dropdown") {
          //   setShowDropdown(true);
          // } else
          if (dragTypeValue === "checkbox") {
            setIsCheckbox(true);
          } else if (dragTypeValue === radioButtonWidget) {
            setIsRadio(true);
          } else if (dragTypeValue === textInputWidget) {
            setIsTextInput(true);
          } else if (dragTypeValue === "date") {
            setIsDateModal(true);
          } else if (
            [textWidget, "name", "company", "job title", "email"].includes(
              dragTypeValue
            )
          ) {
            setFontSize(12);
            setFontColor("black");
          }
          setCurrWidgetsDetails({});
          setWidgetType(dragTypeValue);
          setSignKey(key);
          setSelectWidgetId(key);
        } else {
          setIsReceipent(false);
        }
      } else {
        // setIsAddRole(true);
      }
    } catch (error) {
      console.error("Error fetching template:", error);
    }
  };

  const pageDetails = async (pdf) => {
    let pdfWHObj = [];
    const totalPages = pdf?.numPages;
    for (let index = 0; index < totalPages; index++) {
      const getPage = await pdf.getPage(index + 1);
      const scale = 1;
      const { width, height } = getPage.getViewport({ scale });
      pdfWHObj.push({ pageNumber: index + 1, width, height });
    }
    setPdfOriginalWH(pdfWHObj);
    setPdfLoad(true);
  };

  const handleTabDrag = (key) => {
    setDragKey(key);
    setIsDragging(true);
  };
  //function for change page
  function changePage(offset) {
    setSignBtnPosition([]);
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  //function for capture position on hover or touch widgets
  const handleDivClick = (e) => {
    const isTouchEvent = e.type.startsWith("touch");
    const divRect = e.currentTarget.getBoundingClientRect();
    let mouseX, mouseY;
    if (isTouchEvent) {
      const touch = e.touches[0]; // Get the first touch point
      mouseX = touch.clientX - divRect.left;
      mouseY = touch.clientY - divRect.top;
      setSignBtnPosition([{ xPos: mouseX, yPos: mouseY }]);
    } else {
      mouseX = e.clientX - divRect.left;
      mouseY = e.clientY - divRect.top;
      const xyPosition = { xPos: mouseX, yPos: mouseY };
      setXYSignature(xyPosition);
    }
  };

  //function for capture position of x and y on hover signature button last position
  const handleMouseLeave = () => {
    setSignBtnPosition([xySignature]);
  };
  const handleDeleteSign = (key, Id) => {
    const updateData = [];
    const filterSignerPos = signerPos.filter((data) => data.Id === Id);

    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;

      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber
      );

      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos.filter(
          (data) => data.key !== key
        );

        if (getXYdata.length > 0) {
          updateData.push(getXYdata);
          const newUpdatePos = getPlaceHolder.map((obj) => {
            if (obj.pageNumber === pageNumber) {
              return { ...obj, pos: updateData[0] };
            }
            return obj;
          });

          const newUpdateSigner = signerPos.map((obj) => {
            if (obj.Id === Id) {
              return { ...obj, placeHolder: newUpdatePos };
            }
            return obj;
          });

          setSignerPos(newUpdateSigner);
        } else {
          const getRemainPage = filterSignerPos[0].placeHolder.filter(
            (data) => data.pageNumber !== pageNumber
          );
          //condition to check placeholder length is greater than 1 do not need to remove whole placeholder
          //array only resove particular widgets
          if (getRemainPage && getRemainPage.length > 0) {
            const newUpdatePos = filterSignerPos.map((obj) => {
              if (obj.Id === Id) {
                return { ...obj, placeHolder: getRemainPage };
              }
              return obj;
            });
            let signerupdate = [];
            signerupdate = signerPos.filter((data) => data.Id !== Id);
            signerupdate.push(newUpdatePos[0]);

            setSignerPos(signerupdate);
          } else {
            const updatedData = signerPos.map((item) => {
              if (item.Id === Id) {
                // Create a copy of the item object and delete the placeHolder field
                const updatedItem = { ...item };
                delete updatedItem.placeHolder;
                return updatedItem;
              }
              return item;
            });
            setSignerPos(updatedData);
          }
        }
      }
    }
  };
  //function for set and update x and y postion after drag and drop signature tab
  const handleStop = (event, dragElement, signerId, key) => {
    setFontColor();
    setFontSize();
    if (!isResize && isDragging) {
      const dataNewPlace = addZIndex(signerPos, key, setZIndex);
      let updateSignPos = [...signerPos];
      updateSignPos.splice(0, updateSignPos.length, ...dataNewPlace);
      const signId = signerId; //? signerId : signerObjId;
      const keyValue = key ? key : dragKey;
      const containerScale = getContainerScale(
        pdfOriginalWH,
        pageNumber,
        containerWH
      );
      if (keyValue >= 0) {
        let filterSignerPos;
        if (signId) {
          filterSignerPos = updateSignPos.filter((data) => data.Id === signId);
        } else {
          filterSignerPos = updateSignPos.filter(
            (data) => data.Role === "prefill"
          );
        }
        //// console.log("filterSignerPos", filterSignerPos);
        if (filterSignerPos.length > 0) {
          const getPlaceHolder = filterSignerPos[0].placeHolder;
          const getPageNumer = getPlaceHolder.filter(
            (data) => data.pageNumber === pageNumber
          );
          if (getPageNumer.length > 0) {
            const getXYdata = getPageNumer[0].pos;
            const getPosData = getXYdata;
            const addSignPos = getPosData.map((url) => {
              if (url.key === keyValue) {
                return {
                  ...url,
                  xPosition: dragElement.x / (containerScale * scale),
                  yPosition: dragElement.y / (containerScale * scale),
                };
              }
              return url;
            });

            const newUpdateSignPos = getPlaceHolder.map((obj) => {
              if (obj.pageNumber === pageNumber) {
                return { ...obj, pos: addSignPos };
              }
              return obj;
            });
            const newUpdateSigner = updateSignPos.map((obj) => {
              if (signId) {
                if (obj.Id === signId) {
                  return { ...obj, placeHolder: newUpdateSignPos };
                }
              } else {
                if (obj.Role === "prefill") {
                  return { ...obj, placeHolder: newUpdateSignPos };
                }
              }
              return obj;
            });
            setSignerPos(newUpdateSigner);
          }
        }
      }
    }
    setTimeout(() => setIsDragging(false), 200);
  };

  const handleRoleChange = (event, roleId) => {
    // Update the role when the content changes
    const updatedRoles = signersdata.map((role) =>
      role.Id === roleId ? { ...role, Role: event.target.value } : role
    );
    setSignersData(updatedRoles);
    const updatedPlaceholder = signerPos.map((role) =>
      role.Id === roleId ? { ...role, Role: event.target.value } : role
    );
    setSignerPos(updatedPlaceholder);
  };
  //  `handleOnBlur` function is call when user click outside input box
  const handleOnBlur = (updateRole, roleId) => {
    // Update the role when the content changes
    if (!updateRole) {
      const updatedRoles = signersdata.map((role) =>
        role.Id === roleId ? { ...role, Role: roleName } : role
      );
      setSignersData(updatedRoles);
      const updatedPlaceholder = signerPos?.map((role) =>
        role.Id === roleId ? { ...role, Role: roleName } : role
      );
      setSignerPos(updatedPlaceholder);
    }
  };

  const validatePlaceholders = (payload) => {
    // console.log("payload", payload);
    let hasMissingOneField = false;
    let hasMissingOneFieldErr = "";
    let hasMissingSignature = false;

    // Create a copy of recipients to avoid mutating the original payload
    const recipients = [...payload.recipients];

    for (const recipient of recipients) {
      if (recipient.isCC) {
        continue;
      }

      // console.log("signerPos", signerPos);
      const placeHolder = signerPos.find((pos) => pos.Id === recipient._id);

      if (placeHolder) {
        recipient.placeHolder = placeHolder?.placeHolder || [];
      } else {
        // console.log("else", recipient);
        recipient.placeHolder = [];
      }

      // console.log("recipient.placeHolder", recipient, recipient.placeHolder);

      // Check if recipient has any placeholders
      if (!recipient.placeHolder.length) {
        hasMissingOneField = true;
        hasMissingOneFieldErr = `For ${recipient.role} At least one widget is required`;
        continue;
      }

      // Check for signature widget in each page
      let hasSignatureOnAnyPage = false;
      for (const widget of recipient.placeHolder) {
        const signatureWidget = widget.pos.find(
          (pos) => pos.type === "signature"
        );
        if (signatureWidget) {
          hasSignatureOnAnyPage = true;
          break;
        }
      }

      if (!hasSignatureOnAnyPage) {
        hasMissingSignature = true;
        break;
      }
    }

    // if (hasMissingSignature) {
    //   toast.error("At least one signature is required for all recipients");
    //   return false;
    // }

    if (hasMissingOneField) {
      toast.error(hasMissingOneFieldErr);
      return false;
    }

    return true;
  };
  const handleSaveTemplate = async () => {
    const payload = { ...templateData };
    const isValidate = validatePlaceholders(payload);
    if (!isValidate) {
      return;
    }
    try {
      showLoader();
      await updateTemplate(templateId, {
        ...payload,
        documentConfigured: true,
        recipients: JSON.stringify(payload.recipients),
        documentRequiredMessage: documentRequiredMessage,
        documentRequired: isAskForAttachments,
      });
      toast.success("Template updated successfully");
      navigate(`/dashboard/templates`);
    } catch (error) {
      console.error("Error updating template:", error);
      toast.error(error.message || "Failed to update template");
    } finally {
      hideLoader();
    }
  };
  const prepareSendEmail = (expiryDateTime) => {
    const payload = { ...templateData };
    const isValidate = validatePlaceholders(payload);
    if (!isValidate) {
      return;
    }
    // let hasMissingOneField = false;
    // let hasMissingOneFieldErr = "";
    // let hasMissingSignature = false;
    // payload.recipients.map((recipient) => {
    //   if (recipient.isCC) {
    //     return recipient;
    //   }
    //   const placeHolder = signerPos.find((pos) => pos.Id === recipient._id);
    //   if (placeHolder) {
    //     recipient.placeHolder = placeHolder.placeHolder || [];
    //   }

    //   // check for signnatur widget
    //   for (const widget of recipient.placeHolder) {
    //     const signatureWidget = widget.pos.find(
    //       (pos) => pos.type === "signature"
    //     );
    //     if (!signatureWidget) {
    //       hasMissingSignature = true;
    //       break;
    //     }
    //   }

    //   if (!recipient.placeHolder.length) {
    //     hasMissingOneField = true;
    //     hasMissingOneFieldErr = `For ${recipient.role} At least one widget is required`;
    //   }

    //   return recipient;
    // });

    // if (hasMissingSignature) {
    //   toast.error("At least one signature is required for all recipients");
    //   return;
    // }

    // if (hasMissingOneField) {
    //   toast.error(hasMissingOneFieldErr);
    //   return;
    // }

    if (expiryDateTime) {
      payload.expiryDateTime = expiryDateTime;
    }

    sendEmail({
      ...payload,
      recipients: payload.recipients.map((recipient) => {
        delete recipient._id;
        return recipient;
      }),
      documentRequiredMessage: documentRequiredMessage,
      documentRequired: isAskForAttachments,
    });
  };

  const handleNameModal = () => {
    setIsNameModal(false);
    setCurrWidgetsDetails({});
    setShowDropdown(false);
    setIsRadio(false);
    setIsCheckbox(false);
    setIsTextInput(false);
    setIsDateModal(false);
    //condition for text widget type after set all values for text widget
    //change setUniqueId which is set in tempsignerId
    //because textwidget do not have signer user so for selected signers we have to do
    if (currWidgetsDetails.type === textWidget) {
      setUniqueId(tempSignerId);
      setTempSignerId("");
    }
  };

  const handleSaveDateWidgetOptions = (dateInputType) => {
    const filterSignerPos = signerPos.filter((data) => data.Id === uniqueId);
    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;
      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber
      );
      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos;
        const addSignPos = getXYdata.map((position) => {
          if (position.key === signKey) {
            return {
              ...position,
              options: {
                ...position.options,
                dateInputType,
              },
            };
          }
          return position;
        });
        const newUpdateSignPos = getPlaceHolder.map((obj) =>
          obj.pageNumber === pageNumber ? { ...obj, pos: addSignPos } : obj
        );
        const newUpdateSigner = signerPos.map((obj) =>
          obj.Id === uniqueId ? { ...obj, placeHolder: newUpdateSignPos } : obj
        );
        setSignerPos(newUpdateSigner);
      }
    }
    handleNameModal();
  };

  const handleWidgetClickConfig = (widgetData) => {
    setCurrWidgetsDetails(widgetData);
    setSignKey(widgetData.key);
    setWidgetType(widgetData.type);
    if (widgetData.data && widgetData.data.Id) {
      setUniqueId(widgetData.data.Id);
      const checkIndex = signerPos.findIndex(
        (data) => data.Id === widgetData.data.Id
      );
      setIsSelectId(checkIndex || 0);
    }
    if (widgetData.type === radioButtonWidget) {
      setIsRadio(true);
    } else if (widgetData.type === "dropdown") {
      setShowDropdown(true);
    } else if (widgetData.type === textInputWidget) {
      setIsTextInput(true);
    } else if (widgetData.type === "date") {
      setIsDateModal(true);
    }
  };

  const handleSaveWidgetsOptions = (
    dropdownName,
    dropdownOptions,
    minCount,
    maxCount,
    isReadOnly,
    addOption,
    deleteOption,
    status,
    defaultValue,
    isHideLabel,
    maxLength,
    minLength
  ) => {
    const filterSignerPos = signerPos.filter((data) => data.Id === uniqueId);
    if (filterSignerPos.length > 0) {
      const getPlaceHolder = filterSignerPos[0].placeHolder;

      const getPageNumer = getPlaceHolder.filter(
        (data) => data.pageNumber === pageNumber
      );

      if (getPageNumer.length > 0) {
        const getXYdata = getPageNumer[0].pos;

        const getPosData = getXYdata;
        const addSignPos = getPosData.map((position) => {
          if (position.key === signKey) {
            if (widgetType === radioButtonWidget) {
              if (addOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height + 15
                    : defaultWidthHeight(widgetType).height + 15,
                };
              } else if (deleteOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height - 15
                    : defaultWidthHeight(widgetType).height - 15,
                };
              } else {
                return {
                  ...position,
                  options: {
                    ...position.options,
                    name: dropdownName,
                    values: dropdownOptions,
                    status: status,
                    defaultValue: defaultValue,
                    isReadOnly: isReadOnly || false,
                    isHideLabel: isHideLabel || false,
                    fontSize:
                      fontSize || currWidgetsDetails?.options?.fontSize || 12,
                    fontColor:
                      fontColor ||
                      currWidgetsDetails?.options?.fontColor ||
                      "black",
                  },
                };
              }
            } else if (widgetType === "checkbox") {
              if (addOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height + 15
                    : defaultWidthHeight(widgetType).height + 15,
                };
              } else if (deleteOption) {
                return {
                  ...position,
                  Height: position.Height
                    ? position.Height - 15
                    : defaultWidthHeight(widgetType).height - 15,
                };
              } else {
                return {
                  ...position,
                  options: {
                    ...position.options,
                    name: dropdownName,
                    values: dropdownOptions,
                    validation: {
                      minRequiredCount: minCount,
                      maxRequiredCount: maxCount,
                    },
                    isReadOnly: isReadOnly || false,
                    defaultValue: defaultValue,
                    isHideLabel: isHideLabel || false,
                    fontSize:
                      fontSize || currWidgetsDetails?.options?.fontSize || 12,
                    fontColor:
                      fontColor ||
                      currWidgetsDetails?.options?.fontColor ||
                      "black",
                  },
                };
              }
            } else if (widgetType === textInputWidget) {
              return {
                ...position,
                options: {
                  ...position.options,
                  name: dropdownName,
                  status: status,
                  defaultValue: defaultValue,
                  isReadOnly: isReadOnly || false,
                  fontSize:
                    fontSize || currWidgetsDetails?.options?.fontSize || 12,
                  fontColor:
                    fontColor ||
                    currWidgetsDetails?.options?.fontColor ||
                    "black",
                  maxLength:
                    maxLength || currWidgetsDetails?.options?.maxLength || "",
                  minLength:
                    minLength || currWidgetsDetails?.options?.minLength || "",
                },
              };
            } else {
              return {
                ...position,
                options: {
                  ...position.options,
                  name: dropdownName,
                  status: status,
                  values: dropdownOptions,
                  defaultValue: defaultValue,
                  fontSize:
                    fontSize || currWidgetsDetails?.options?.fontSize || 12,
                  fontColor:
                    fontColor ||
                    currWidgetsDetails?.options?.fontColor ||
                    "black",
                  ...(isReadOnly ? { isReadOnly: isReadOnly || false } : {}),
                },
              };
            }
          }
          return position;
        });

        const newUpdateSignPos = getPlaceHolder.map((obj) => {
          if (obj.pageNumber === pageNumber) {
            return { ...obj, pos: addSignPos };
          }
          return obj;
        });
        const newUpdateSigner = signerPos.map((obj) => {
          if (obj.Id === uniqueId) {
            return { ...obj, placeHolder: newUpdateSignPos };
          }
          return obj;
        });

        setSignerPos(newUpdateSigner);
        if (!addOption && !deleteOption) {
          handleNameModal();
        }
      }
    }
    setFontSize();
    setFontColor();
  };
  const handleAttachmentChange = (e, signerId) => {
    const updatedSigners = templateData.recipients.map((signer) =>
      signer._id === signerId
        ? { ...signer, requiredAttachment: e.target.checked }
        : signer
    );
    setTemplateData({ ...templateData, recipients: updatedSigners });
  };

  return (
    <PagePermissionGuard
      module="templates"
      action="update"
      pageName="Configure Document"
    >
      <div>
        {/* <DndProvider backend={HTML5Backend}> */}
        <div className="h-screen overflow-hidden">
          <div className="rounded-lg shadow-lg bg-white relative op-card overflow-hidden flex flex-col md:flex-row justify-between">
            <div className="w-[23%] bg-base-100 min-h-screen max-h-screen overflow-y-auto hide-scrollbar bg-slate-100">
              <PrevNext
                pageNumber={pageNumber}
                allPages={allPages}
                changePage={changePage}
              />
              <hr />
              <SignerListPlace
                signerPos={signerPos}
                setSignerPos={setSignerPos}
                signersdata={signersdata}
                isSelectListId={isSelectListId}
                setRoleName={setRoleName}
                setIsSelectId={setIsSelectId}
                handleAddSigner={() => {}}
                setUniqueId={setUniqueId}
                handleDeleteUser={() => {}}
                handleRoleChange={handleRoleChange}
                handleOnBlur={handleOnBlur}
                title={"Roles"}
                sendInOrder={templateData?.isSequential}
                setSignersData={setSignersData}
                blockColor={blockColor}
                setBlockColor={setBlockColor}
                uniqueId={uniqueId}
              />
              <PlaceholderCopy
                isPageCopy={isPageCopy}
                setIsPageCopy={setIsPageCopy}
                xyPosition={signerPos}
                setXyPosition={setSignerPos}
                allPages={allPages}
                pageNumber={pageNumber}
                signKey={signKey}
                Id={uniqueId}
                widgetType={widgetType}
                setUniqueId={setUniqueId}
                tempSignerId={tempSignerId}
                setTempSignerId={setTempSignerId}
              />
              <div data-tut="addWidgets">
                <WidgetComponent
                  handleDivClick={handleDivClick}
                  handleMouseLeave={handleMouseLeave}
                  isSignYourself={false}
                  addPositionOfSignature={addPositionOfSignature}
                  title={"Roles"}
                  initial={true}
                  isTemplateFlow={true}
                />
                <DropdownWidgetOption
                  type="checkbox"
                  title={"Checkbox"}
                  showDropdown={isCheckbox}
                  setShowDropdown={setIsCheckbox}
                  handleSaveWidgetsOptions={handleSaveWidgetsOptions}
                  currWidgetsDetails={currWidgetsDetails}
                  setCurrWidgetsDetails={setCurrWidgetsDetails}
                  handleClose={handleNameModal}
                  fontSize={fontSize}
                  setFontSize={setFontSize}
                  fontColor={fontColor}
                  setFontColor={setFontColor}
                  isShowAdvanceFeature={true}
                />

                <DropdownWidgetOption
                  type={radioButtonWidget}
                  title={"Radio Button"}
                  showDropdown={isRadio}
                  setShowDropdown={setIsRadio}
                  handleSaveWidgetsOptions={handleSaveWidgetsOptions}
                  currWidgetsDetails={currWidgetsDetails}
                  setCurrWidgetsDetails={setCurrWidgetsDetails}
                  handleClose={handleNameModal}
                  fontSize={fontSize}
                  setFontSize={setFontSize}
                  fontColor={fontColor}
                  setFontColor={setFontColor}
                  isShowAdvanceFeature={true}
                />

                <TextInputWidgetOption
                  type={textInputWidget}
                  title={"Text Input"}
                  showDropdown={isTextInput}
                  setShowDropdown={setIsTextInput}
                  handleSaveWidgetsOptions={handleSaveWidgetsOptions}
                  currWidgetsDetails={currWidgetsDetails}
                  setCurrWidgetsDetails={setCurrWidgetsDetails}
                  handleClose={handleNameModal}
                  fontSize={fontSize}
                  setFontSize={setFontSize}
                  fontColor={fontColor}
                  setFontColor={setFontColor}
                />

                <DateWidgetOption
                  isOpen={isDateModal}
                  onClose={handleNameModal}
                  onSave={handleSaveDateWidgetOptions}
                  initialDateInputType={
                    currWidgetsDetails?.options?.dateInputType || "free"
                  }
                />
              </div>
              <div className="p-4 bg-gray-50 border-t border-gray-200">
                <div className="flex flex-col gap-3">
                  <div className="flex flex-col gap-3">
                    {isFromSelfSign && (
                      <button
                        onClick={() => {
                          const payload = { ...templateData };
                          validatePlaceholders(payload);
                          continueSignCallBack(payload);
                        }}
                        className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-2 bg-green-600 border border-transparent rounded-lg text-lg font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200 shadow-sm"
                      >
                        <CheckBadgeIcon className="w-6 h-6 mr-2" />
                        Continue Signing
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className=" w-full md:w-[57%] flex border-x-2 border-gray-300">
              <div className="w-full md:w-[90%] mx-auto h-[100%]">
                <div ref={divRef} data-tut="reactourThird" className="h-[80%]">
                  {containerWH && (
                    <RenderPdf
                      pageNumber={pageNumber}
                      pdfNewWidth={pdfNewWidth}
                      pdfDetails={templateData}
                      signerPos={signerPos}
                      successEmail={false}
                      numPages={1}
                      pageDetails={pageDetails}
                      placeholder={true}
                      drop={drop}
                      handleDeleteSign={handleDeleteSign}
                      handleTabDrag={handleTabDrag}
                      handleStop={handleStop}
                      setPdfLoad={setPdfLoad}
                      pdfLoad={pdfLoad}
                      setSignerPos={setSignerPos}
                      containerWH={containerWH}
                      setIsResize={setIsResize}
                      setZIndex={setZIndex}
                      handleLinkUser={() => {}}
                      setUniqueId={setUniqueId}
                      signersdata={signersdata}
                      setIsPageCopy={setIsPageCopy}
                      setSignKey={setSignKey}
                      isDragging={isDragging}
                      setShowDropdown={setShowDropdown}
                      setCurrWidgetsDetails={setCurrWidgetsDetails}
                      setWidgetType={setWidgetType}
                      setIsRadio={setIsRadio}
                      setSelectWidgetId={setSelectWidgetId}
                      selectWidgetId={selectWidgetId}
                      setIsCheckbox={setIsCheckbox}
                      setIsTextInput={setIsTextInput}
                      handleNameModal={setIsNameModal}
                      handleWidgetClick={handleWidgetClickConfig}
                      pdfOriginalWH={pdfOriginalWH}
                      setScale={setScale}
                      scale={scale}
                      setIsSelectId={setIsSelectId}
                      pdfBase64Url={pdfBase64Url}
                      fontSize={fontSize}
                      setFontSize={setFontSize}
                      fontColor={fontColor}
                      setFontColor={setFontColor}
                      isResize={isResize}
                      divRef={divRef}
                      setTempSignerId={setTempSignerId}
                      uniqueId={uniqueId}
                      unSignedWidgetId={unSignedWidgetId}
                    />
                  )}
                </div>
              </div>
            </div>
            <RenderAllPdfPage
              allPages={allPages}
              setAllPages={setAllPages}
              signerPos={signerPos}
              setPageNumber={setPageNumber}
              setSignBtnPosition={setSignBtnPosition}
              pageNumber={pageNumber}
              pdfBase64Url={pdfBase64Url}
              signedUrl={templateData?.documentId?.path || ""}
              setPdfArrayBuffer={setPdfArrayBuffer}
              setPdfBase64Url={setPdfBase64Url}
              setIsUploadPdf={setIsUploadPdf}
              pdfArrayBuffer={pdfArrayBuffer}
              isMergePdfBtn={false}
              changePage={changePage}
              from="desktop"
            />

            {isSignPad && (
              <SignPad
                saveSignCheckbox={saveSignCheckbox}
                setSaveSignCheckbox={setSaveSignCheckbox}
                signatureTypes={signatureType}
                isSignPad={isSignPad}
                isStamp={isStamp}
                setIsImageSelect={setIsImageSelect}
                setIsSignPad={setIsSignPad}
                setImage={setImage}
                isImageSelect={isImageSelect}
                imageRef={imageRef}
                onImageChange={onImageChange}
                setSignature={setSignature}
                image={image}
                onSaveImage={saveImage}
                onSaveSign={saveSign}
                defaultSign={defaultSignImg}
                myInitial={myInitial}
                setDefaultSignImg={setDefaultSignImg}
                setMyInitial={setMyInitial}
                isInitial={isInitial}
                setIsInitial={setIsInitial}
                setIsStamp={setIsStamp}
                currWidgetsDetails={currWidgetsDetails}
                setCurrWidgetsDetails={setCurrWidgetsDetails}
                setIsAutoSign={setIsAutoSign}
                isAutoSign={isAutoSign}
                userDetails={
                  signerPos?.find((item) => item.contactId === "self") || null
                }
              />
            )}
          </div>
        </div>
        {/* </DndProvider> */}

        <SendConfirmationModal
          isOpen={showSendModal}
          onClose={() => setShowSendModal(false)}
          onConfirm={(expiryDateTime) => prepareSendEmail(expiryDateTime)}
        />
      </div>
    </PagePermissionGuard>
  );
};

export default SelfSignConfigure;
